import type { IconData } from '@stacksjs/iconify-core'

export const ch4x3: IconData = {
  "body": "<g fill-rule=\"evenodd\" stroke-width=\"1pt\"><path fill=\"red\" d=\"M0 0h640v480H0z\"/><g fill=\"#fff\"><path d=\"M170 195h300v90H170z\"/><path d=\"M275 90h90v300h-90z\"/></g></g>",
  "width": 640,
  "height": 480,
  "viewBox": "0 0 640 480"
}

export default ch4x3
